import { ReactElement } from 'react';

import { PrismicRichText } from '@prismicio/react';

import { IProps } from './types';
import * as S from './styles';

export function SliceRichText({ slice: { primary } }: IProps): ReactElement {
  return (
    <S.Wrapper
      className={`slice-item slice-rich-text ${
        primary.classes ? primary.classes : ''
      }`}
    >
      <PrismicRichText field={primary.rich_text} />
    </S.Wrapper>
  );
}

SliceRichText.componentName = 'richtext';
